const routes = [
    {
        path: "/housing/reports",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            isStaff:true
        }
    },
    {
        path: "/housing/payment-report",
        component: () => import("../pages/PaymentReport.vue"),
        meta: {
            isAuthenticated: true,
            isStaff:true
        }
    }
];

export default routes;
